export default {
      id: "261,8=1,7+45+70+28,4+70+45+1,7-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#261,8=1,7+45+70+28,4+70+45+1,7",
      toString: function () {
        return this.url;
      }
    }